// Mock data for Creduce Technologies website

export const companyStats = {
  carbonCreditsTraded: 50000000,
  projectsActive: 400,
  clients: 250,
  creditsIssued: 20000000,
  domains: 8,
  yearsExperience: 15
};

export const services = [
  {
    id: 1,
    title: "Carbon Project Development & Management",
    description: "Monetize carbon offset opportunities through verified carbon credits. Design, register, and manage renewable energy and emission reduction projects.",
    icon: "leaf",
    features: [
      "IREC and Plastic Credit generation",
      "UN SDG alignment",
      "Verified carbon credit development"
    ]
  },
  {
    id: 2,
    title: "Carbon Neutrality / Net Zero",
    description: "Comprehensive Carbon Footprint Assessments tailored to your operations with measurable targets and certification.",
    icon: "target",
    features: [
      "Carbon footprint assessments",
      "Emission reduction roadmaps",
      "Net Zero certification"
    ]
  },
  {
    id: 3,
    title: "Sustainability & ESG Reporting",
    description: "Expertise in BRSR, GRI, and SASB frameworks with comprehensive data collection, analysis, and ESG disclosure consulting.",
    icon: "file-text",
    features: [
      "BRSR, GRI, SASB frameworks",
      "ESG disclosure consulting",
      "Sustainability integration"
    ]
  },
  {
    id: 4,
    title: "Nature-Based & Community Solutions",
    description: "Develop and manage projects in biodiversity conservation, afforestation, and soil carbon restoration with community partnerships.",
    icon: "sprout",
    features: [
      "Biodiversity conservation",
      "Afforestation projects",
      "Community partnerships"
    ]
  },
  {
    id: 5,
    title: "Carbon & Renewable Trading",
    description: "Seamless digital trading of Carbon Credits, IRECs, and Plastic Credits with AI-driven analytics for smarter decisions.",
    icon: "trending-up",
    features: [
      "Carbon Credits trading",
      "IREC trading",
      "AI-driven analytics"
    ]
  },
  {
    id: 6,
    title: "Climate Finance & Investments",
    description: "Mobilize green capital and unlock climate-positive growth through sustainable finance mechanisms. We connect investors, developers, and institutions to scalable carbon, renewable, and adaptation projects.",
    icon: "dollar-sign",
    features: [
      "Climate finance structuring",
      "Green bonds and carbon-linked instruments",
      "Investment facilitation for climate projects"
    ]
  },
  {
    id: 7,
    title: "Climate Risk, Resilience & Adaptation",
    description: "Assess, quantify, and manage physical and transition climate risks to future-proof businesses and infrastructure against climate volatility and regulatory change.",
    icon: "shield-alert",
    features: [
      "Climate risk & vulnerability assessments",
      "TCFD / IFRS S2 aligned disclosures",
      "Climate adaptation & resilience strategies",
      "Asset-level and supply-chain risk mapping"
    ]
  },
  {
    id: 8,
    title: "Energy Transition & Decarbonization Advisory",
    description: "End-to-end support for organizations transitioning to low-carbon energy systems through strategic planning, technology deployment, and regulatory alignment.",
    icon: "zap",
    features: [
      "Renewable energy transition planning",
      "Green hydrogen & storage advisory",
      "Energy efficiency & optimization programs",
      "Scope 1, 2 & 3 decarbonization strategies"
    ]
  }
];

export const timeline = [
  {
    year: 2012,
    title: "Foundation",
    description: "Founded as Envarrior to provide carbon project development & trading services"
  },
  {
    year: 2021,
    title: "Rebirth as Creduce",
    description: "Rebranded as Creduce Technologies Pvt. Ltd. with renewed mission"
  },
  {
    year: 2022,
    title: "Industry Recognition",
    description: "Awarded Energy Startup of the Year; issued India's largest Carbon Credits for SJVN"
  },
  {
    year: 2023,
    title: "Expansion",
    description: "Initiated Nature-Based Solutions and IREC Trading"
  },
  {
    year: 2024,
    title: "Global Footprint",
    description: "Launched trading desk in Dubai, expanded to Morocco and London"
  },
  {
    year: 2025,
    title: "Digital Future",
    description: "Advancing towards a fully digital global climate asset platform"
  }
];

export const globalOffices = [
  {
    id: 1,
    city: "Ahmedabad",
    country: "India",
    type: "Headquarters",
    lat: 23.0225,
    lng: 72.5714
  },
  {
    id: 2,
    city: "Jaipur",
    country: "India",
    type: "Representative Office",
    lat: 26.9124,
    lng: 75.7873
  },
  {
    id: 3,
    city: "Noida",
    country: "India",
    type: "Representative Office",
    lat: 28.5355,
    lng: 77.3910
  },
  {
    id: 4,
    city: "Mumbai",
    country: "India",
    type: "Representative Office",
    lat: 19.0760,
    lng: 72.8777
  },
  {
    id: 5,
    city: "Dubai",
    country: "UAE",
    type: "Trading Desk",
    lat: 25.2048,
    lng: 55.2708
  },
  {
    id: 6,
    city: "London",
    country: "UK",
    type: "Representative Office",
    lat: 51.5074,
    lng: -0.1278
  },
  {
    id: 7,
    city: "Morocco",
    country: "Morocco",
    type: "Representative Office",
    lat: 31.7917,
    lng: -7.0926
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "SJVN Renewable Energy Project",
    type: "Renewable Energy",
    credits: "47M+ Credits Issued",
    description: "India's largest carbon credit issuance for renewable energy (Hydro) project",
    sdgs: [7, 13],
    image: null
  },
  {
    id: 2,
    title: "100k Hectare Bamboo Afforestation Project By APBRDA (Arunachal Pradesh)",
    type: "Nature-Based Solution",
    credits: "5M+ Credits",
    description: "Large-scale bamboo afforestation project transforming landscapes and empowering communities",
    sdgs: [15, 13],
    image: null
  },
  {
    id: 3,
    title: "Waste PET Bottle Recycling Project in Morocco",
    type: "Waste Management",
    credits: "50k+ Credits",
    description: "Converting PET waste to Food grade granule",
    sdgs: [7, 11, 12],
    image: null
  }
];

export const teamMembers = [
  {
    name: "Shailendra Singh Rao",
    role: "Founder & Managing Director",
    email: "Shailendra@creduce.org",
    phone: "+91 90168 50742"
  }
];

export const faqData = [
  {
    question: "What are Carbon Credits?",
    answer: "Carbon credits are tradable certificates representing the reduction of one metric ton of carbon dioxide emissions. They are used by companies and governments to offset their carbon footprint."
  },
  {
    question: "How can my company achieve Net Zero?",
    answer: "Achieving Net Zero involves measuring your carbon footprint, implementing emission reduction strategies, and offsetting remaining emissions through verified carbon credits. Creduce provides end-to-end support for this journey."
  },
  {
    question: "What is IREC?",
    answer: "International Renewable Energy Certificates (IRECs) are tradable instruments that represent proof that electricity was generated from renewable energy sources. One IREC equals 1 MWh of renewable electricity."
  },
  {
    question: "How long does carbon project development take?",
    answer: "The timeline varies based on project type and complexity, typically ranging from 12-24 months from initial assessment to credit issuance. Our team manages the entire process efficiently."
  }
];